import { mapState, mapActions, mapMutations } from "vuex";
export default {
	props: ["lop"],

	data() {
		return {
			truong: [],
			truongId: "",
			tinhId: "",
		};
	},
	computed: {
		...mapState({
			tinhs: (state) => state.truong.tinhs,
		}),
		thongtinlop() {
			return this.$store.state.truong[`thongtinlop${this.lop}`];
		},
	},
	methods: {
		...mapActions({
			getNganhs: "nganh/getNganhs",
			getTruongByMaTinh: "truong/getTruongByMaTinh",
		}),
		...mapMutations({
			updateTruongId: "thisinh/updateTruongId",
		}),
		getTruongs() {
			this.truongId = "";
			this.getTruongByMaTinh({ matinh: this.tinhId, lop: this.lop })
				.then((response) => {
					if (response.status === 200) this.truong = response.data;
				})
				.catch((err) => console.error(err.message));
		},
		updateMaTruong() {
			this.updateTruongId({ truongId: this.truongId, lop: this.lop });
		},
	},
	created() {
		this.truongId = this.thongtinlop.truongId;
		this.tinhId = this.thongtinlop.tinhId;
	},
	watch: {
		async thongtinlop(newValue) {
			if (newValue.truongId !== this.truongId) {
				this.truongId = newValue.truongId;
			}
			if (newValue.tinhId != this.truongId) {
				this.tinhId = newValue.tinhId;
				await this.getTruongs();
				this.truongId = newValue.truongId;
			}
		},
	},
};
